import type { CustomerMembershipDto } from "../../api/hooks/useMemberships";
import { type MembershipRequestDto, MembershipRequestStatus } from "../../api/hooks/useMembershipRequests";

/** Where the customer stands with a tier: held, asked about and waiting, declined, or neither. */
export type TierStanding = "held" | "pending" | "declined" | "none";

export function tierStandings(
  memberships: CustomerMembershipDto[],
  requests: MembershipRequestDto[],
): (tierId: string) => TierStanding {
  const held = new Set(memberships.map((membership) => membership.membershipTierId));
  const requestByTier = new Map(requests.map((request) => [request.membershipTierId, request]));

  return (tierId) => {
    if (held.has(tierId)) return "held";
    const status = requestByTier.get(tierId)?.status;
    if (status === MembershipRequestStatus.PendingApproval) return "pending";
    if (status === MembershipRequestStatus.Declined) return "declined";
    return "none";
  };
}
